import { EnumTranslationService } from './../../services/enum-translation.service';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, forwardRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IdProvider } from '../id-provider';

@Component({
    selector: 'app-button-group',
    templateUrl: './button-group.component.html',
    styleUrls: ['./button-group.component.scss'],
    imports: [ReactiveFormsModule, NgClass, TranslateModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ButtonGroupComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => ButtonGroupComponent),
            multi: true
        }
    ]
})
export class ButtonGroupComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @Input() public fieldsEnum: any;
  @Input() public hide: any[];
  @Input() public translateKey = '';
  @Input() public fixedWidth = true;
  @Input() public inline = false;

  public id: string = IdProvider.getNextId();
  public form: UntypedFormGroup;
  public keyList: any[];
  public disabled: boolean;

  private subscriptions: Subscription[] = [];

  constructor(private formBuilder: UntypedFormBuilder,
              private enumTranslationService: EnumTranslationService) {
    this.form = this.formBuilder.group({
      formValue: null
    });

    this.subscriptions.push(
      // any time the inner form changes update the parent of any change
      this.form.valueChanges.subscribe(value => {
        this.onChange(value?.formValue);
        this.onTouched();
      })
    );
  }

  public onChange: any = () => {};
  public onTouched: any = () => {};

  ngOnInit() {
    this.keyList = this.getKeys();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public writeValue(value: any): void {
    this.form.controls.formValue.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  public registerOnChange(fn) {
    this.onChange = fn;
  }

  public registerOnTouched(fn) {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    if (this.disabled) {
      this.form.controls.formValue.disable();
    } else {
      this.form.controls.formValue.enable();
    }
  }

  public validate(_: UntypedFormControl) {
    return null;
  }

  private getKeys(): any[] {
    return this.enumTranslationService.translateNumericEnum(this.fieldsEnum, this.translateKey)
      .filter(item => !this.hide.some(e => e === item.value));
  }
}
